module.exports = __webpack_public_path__ + "img/checked.426321de.svg";